import React, { Component } from 'react'
import {
  Box,
  Button,
  Calendar,
  DataTable,
  FormField,
  Heading,
  Main,
  Meter,
  Select,
  Text,
  Tip
} from 'grommet'
import axios from 'axios'
import { DropWithHeading, PageHeader, FileDataRowDetails } from './Common'
import { appSheet, core } from '../api/retail'
import { buildBody, getMonthEnd } from '../libs/appsSheet'
import { AppContext } from '../libs/context'
import GridLoader from 'react-spinners/GridLoader'
import {
  CloudDownload,
  DocumentDownload,
  DocumentPdf,
  Download,
  Filter,
  FormCheckmark
} from 'grommet-icons'
import update from 'immutability-helper'
import { SelectSupplierReceiver } from './Select'
class GeneratedFiles extends Component {
  static contextType = AppContext

  defaultState = {
    files: [],
    perStoreFiles: [],
    downloadFiles: {},
    submitting: false,
    showLayer: false,
    apiLoading: false,
    selectedCompanyId: '',
    selectedReceiverId: ''
  }
  state = { ...this.defaultState, selectedDate: getMonthEnd() }
  componentDidMount() {
    this.loadFromAppSheet()
  }
  componentDidUpdate(prevProps, prevState, snapsho) {
    const companyChanged = prevState.selectedCompanyId !== this.state.selectedCompanyId
    const receiverChanged = prevState.selectedReceiverId !== this.state.selectedReceiverId
    const dateChanged = prevState.selectedDate !== this.state.selectedDate
    if (companyChanged || receiverChanged || dateChanged) {
      this.loadFromAppSheet()
    }
  }
  getGeneratedFiles = () => {
    const { showStatus, selectedCompanyId, selectedReceiverId, selectedDate } = this.state
    let queryFilters = ["[entry_date] = '" + selectedDate.slice(0, 10) + "'"]
    if (selectedCompanyId) {
      queryFilters.push('[company_id] = ' + selectedCompanyId)
    }
    if (selectedReceiverId) {
      queryFilters.push('[receiver_id] = ' + selectedReceiverId)
    }

    let selector = ''
    queryFilters.forEach((item) => (selector += item + ','))

    const properties = {
      Selector:
        'ORDERBY(' +
        (queryFilters.length > 1
          ? 'Filter(GeneratedFile, AND(' + queryFilters + '))'
          : 'Filter(GeneratedFile, ' + queryFilters[0] + ')') +
        ',[creation_time],TRUE)'
    }

    return appSheet.postAction('GeneratedFile', buildBody('Find', properties))
  }
  getFileKey = (file) => {
    const { receivers, companies, stores } = this.context
    const receiverName = file.receiver_id ? receivers[file.receiver_id].name : 'nR'
    const companyName = file.company_id ? companies[file.company_id].name : 'nC'
    const storeName = file.store_id ? stores[file.store_id].name : 'nS'

    const fileKey = [...receiverName.split(' '), ...companyName.split(' '), ...storeName.split(' ')]
    return fileKey
  }
  loadFromAppSheet = () => {
    console.log('Loading from AppSheet')
    this.setState({ apiLoading: true })
    const responses = Promise.all([this.getGeneratedFiles()])
    responses
      .then((result) => {
        // these should already be ordered by creation time, no need to resort
        const files = result[0].data.data
        const byStoreId = {}
        const perStoreFiles = []
        let counter = 0
        files.forEach((file) => {
          // const fileKey = this.getFileKey(file)
          const fileKey = file.publish_file_id
          if (byStoreId[fileKey] === undefined) {
            byStoreId[fileKey] = null
          }
          if (byStoreId[fileKey] === null) {
            byStoreId[fileKey] = file.id
            perStoreFiles.push({ ...file, index: counter })
            counter = counter + 1
          }
        })
        this.setState({
          apiLoading: false,
          files: files,
          perStoreFiles: perStoreFiles
        })
      })
      .catch((err) => this.context.actions.showResponseAsError(err))
  }
  changeCompany = (data) => {
    if (data.receiver_type) {
      this.setState({ ...this.defaultState, selectedReceiverId: data.id })
    } else {
      this.setState({ ...this.defaultState, selectedCompanyId: data.id })
    }
  }
  fileProgress = (index, progressEvent) => {
    const data = this.state.perStoreFiles[index]
    let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    console.log(data.file_uri, percentCompleted)
    const updatedObj = update(this.state.downloadFiles, { [index]: { $set: percentCompleted } })
    this.setState({ downloadFiles: updatedObj })
  }
  getBlob = (index) => {
    const data = this.state.perStoreFiles[index]
    const appSheetUrl = process.env.NODE_ENV === 'production' ? 'https://www.appsheet.com' : ''
    const path =
      appSheetUrl +
      '/template/gettablefileurl?appName=Publish-738426&tableName=GeneratedFile&fileName=' +
      data.file_uri
    const fileKey = this.getFileKey(data)
    const fileName = [...fileKey, data.entry_date + '.' + this.getFileExt(data.file_uri)].join('_')
    axios({
      url: path,
      method: 'GET',
      responseType: 'blob', // important
      onDownloadProgress: (event) => this.fileProgress(index, event)
    }).then((response) => {
      console.log(response)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    })
  }
  getFileExt = (fileUri) => {
    return fileUri.split('.')[1]
  }
  downloadAll = () => {
    this.state.perStoreFiles.forEach((file) => this.getBlob(file.index))
  }
  getSupplierReceiverName = (id, receiver = false) => {
    const { companies, receivers } = this.context
    if (!id) {
      return
    }
    if (receiver) {
      return receivers[id].name
    } else {
      return companies[id].name
    }
  }
  render() {
    const { companies, receivers, stores } = this.context
    const companiesById = companies
    const receiversById = receivers
    const storesById = stores
    const {
      files,
      perStoreFiles,
      apiLoading,
      selectedCompanyId,
      selectedReceiverId,
      selectedDate
    } = this.state
    return (
      <Box fill>
        <PageHeader heading={'Generated Files'}>
          <Heading level={5} margin="small">
            Files: {perStoreFiles.length}
          </Heading>

          <Box flex={'grow'} />
          <Button
            size={'small'}
            hoverIndicator
            plain={false}
            label={'Download'}
            color={'light-3'}
            icon={<CloudDownload color={'dark-6'} />}
            onClick={() => this.downloadAll()}
          />
          <DropWithHeading
            icon={<Filter color={'dark-6'} />}
            heading={'filters'}
            label={
              this.getSupplierReceiverName(
                selectedReceiverId || selectedCompanyId,
                selectedReceiverId
              ) || 'All'
            }
          >
            <FormField label="SUPPLIER / RECEIVER">
              <SelectSupplierReceiver
                plain
                value={{ companyId: selectedCompanyId, receiverId: selectedReceiverId }}
                onChange={({ option }) => this.changeCompany(option)}
              />
            </FormField>
            <FormField label="DATE">
              <Box
                pad={{ bottom: 'small' }}
                fill={'horizontal'}
                justify={'center'}
                align={'center'}
              >
                <Calendar
                  fill
                  size={'small'}
                  date={selectedDate}
                  onSelect={(date) => {
                    this.setState({ selectedDate: date })
                  }}
                />
              </Box>
            </FormField>
          </DropWithHeading>
        </PageHeader>

        <Main flex="shrink">
          {apiLoading ? (
            <Box fill align="center" justify="center">
              <GridLoader color={'#888'} loading={true} size={25} />
            </Box>
          ) : (
            <DataTable
              sortable
              resizeable
              rowDetails={FileDataRowDetails}
              primaryKey="id"
              pin
              // groupBy={selectedCompanyId ? 'store_id' : 'company_id'}
              columns={[
                {
                  property: 'publish_file_id',
                  header: (
                    <Tip content={'Publish file ID'}>
                      <Text>PB ID</Text>
                    </Tip>
                  ),
                  primary: true,
                  search: true
                },
                {
                  property: 'company_id',
                  header: 'Company',
                  size: 'small',
                  render: (datum) => (
                    <Box key={datum.company_id} pad={{ vertical: 'xsmall' }}>
                      <Text>
                        {companiesById[datum.company_id]
                          ? companiesById[datum.company_id].name
                          : ''}
                      </Text>
                    </Box>
                  )
                },
                {
                  property: 'store_id',
                  header: <Text>Store</Text>,
                  render: (datum) => (
                    <Box key={datum.store_id} pad={{ vertical: 'xsmall' }}>
                      <Text>
                        {storesById[datum.store_id] ? storesById[datum.store_id].name : ''}
                      </Text>
                    </Box>
                  )
                },
                {
                  property: 'receiver_id',
                  header: <Text>Receiver</Text>,
                  render: (datum) => (
                    <Box key={datum.receiver_id} pad={{ vertical: 'xsmall' }}>
                      <Text>
                        {receiversById[datum.receiver_id]
                          ? receiversById[datum.receiver_id].name
                          : ''}
                      </Text>
                    </Box>
                  )
                },
                // {
                //   property: 'id',
                //   header: 'ID',
                //   size: 'xxsmall',
                //   search: true
                // },
                {
                  property: 'file_type',
                  size: 'xxsmall',
                  header: <Text>TYPE</Text>,
                  render: (datnum) => <Text>{this.getFileExt(datnum.file_uri)}</Text>
                },
                {
                  property: 'entry_date',
                  size: 'xsmall',
                  header: <Text>ENTRY DATE</Text>
                },
                {
                  property: 'creation_time',
                  size: 'small',
                  header: <Text>CREATION TIME</Text>
                },
                {
                  property: 'file_status',
                  size: 'xxsmall',
                  render: ({ file_status }) => (
                    <Tip content={file_status}>
                      <Box>
                        <FormCheckmark
                          color={
                            file_status && file_status.split(':')[3].trim() === 'SUCCESS'
                              ? 'status-ok'
                              : 'light-4'
                          }
                        />
                      </Box>
                    </Tip>
                  )
                },
                {
                  property: 'file_uri',
                  size: 'xxsmall',
                  header: <Text>FILE</Text>,
                  render: (datnum) => (
                    <Box
                      fill
                      pad={'small'}
                      // height={{ min: 'xxsmall' }}
                      flex={false}
                      align={'center'}
                      justify={'center'}
                      hoverIndicator
                      round
                      onClick={() =>
                        !this.state.downloadFiles[datnum.index] && this.getBlob(datnum.index)
                      }
                    >
                      {this.state.downloadFiles[datnum.index] ? (
                        <Meter
                          max={100}
                          type={'circle'}
                          round
                          size="24px"
                          thickness={'4px'}
                          value={this.state.downloadFiles[datnum.index]}
                        />
                      ) : (
                        <DocumentDownload size={'24px'} />
                      )}
                    </Box>
                  )
                }
              ]}
              data={perStoreFiles}
            />
          )}
        </Main>
      </Box>
    )
  }
}
export default GeneratedFiles
